import {styled} from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import makeStyles from '@mui/styles/makeStyles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import {useState} from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from '../../assets/jss/Report/UserInfoStyle';
import {useParams} from 'react-router';
import {Grid} from "@mui/material";
import {digitsEnToFa} from "persian-tools2";

const useStyles = makeStyles(styles);

// *************** accordion styles *******************
const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({theme}) => ({
    margin: '0 auto',
    marginBottom: '24px',
    borderRadius: '16px',
    width: '90%',
    boxShadow:
        '-10px -10px 20px #FFFFFF, 10px 10px 10px rgba(174, 174, 192, 0.2)',
    border: '1px solid #FFFFFF',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ExpandMoreIcon sx={{fontSize: '1.3rem', color: '#707070'}}/>}
        {...props}
    />
))(({theme}) => ({
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
    margin: 0,
}));

const MainAccordion = (props) => {
    const classes = useStyles();
    const [expanded, setExpanded] = useState('panel1');
    const {header,subHeaderHypo, children} = props
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    return (
        <Accordion
            sx={{
                background: expanded === 'panel1' ? '#F4F4F4' : '#EEEEEE',
            }}
            expanded={expanded === 'panel1'}
            onChange={handleChange('panel1')}>
            <AccordionSummary
                aria-controls='panel1d-content'
                id='panel1d-header'
                expandIcon={expanded === 'panel1' ? <RemoveIcon/> : <AddIcon/>}>
                <Grid container>
                    <Grid xs={12} item className={classes.centerContainer}>
                        <span className={classes.mainAccHeader}>{header}</span>
                    </Grid>
                    <Grid xs={12} item className={classes.centerContainer} pt='11px'>
                        {subHeaderHypo && (
                            <span className={classes.subAccHeader}>
                                تحلیل ها بر اساس
                                <span className={classes.subAccHeaderRed}>
                                  {' '}
                                    {digitsEnToFa(subHeaderHypo)} روز گذشته
                                </span>
                              </span>
                        )}
                    </Grid>
                </Grid>
                {/*<p className={classes.mainAccHeader}>{header}</p>*/}
            </AccordionSummary>
            <div
                style={{
                    margin: 'auto',
                    width: '70%',
                    height: '1.5px',
                    background: '#F9FAFB',
                    boxShadow:
                        '-0.2px -0.5px 1px #FFFFFF, 0.5px 0.75px 1px rgba(174, 174, 192, 0.6)',
                }}
            />
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    );
};

export default MainAccordion;
